import { createContext, useContext } from 'react';

import { BaseRow } from '@sbu/components.datagrid';

import { defaultInitialDataGridPageState } from './constants';
import { DataGridPageState } from './types';

export const DataGridPageContext = createContext<DataGridPageState<any>>(
  defaultInitialDataGridPageState
);

export const useDataGridPageContext = <Row extends BaseRow>() => {
  return useContext<DataGridPageState<Row>>(DataGridPageContext);
};
